export default __webpack_public_path__ + "static/media/pa_2.7da35fad.mp3";